export default __webpack_public_path__ + "static/media/CSharp CRUD CERT.8f08361a.png";